module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_5_EMPRENDIMIENTO.7288c8e4.jpg";